"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketEventToJSON = exports.WebsocketEventFromJSONTyped = exports.WebsocketEventFromJSON = exports.WebsocketEvent = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var WebsocketEvent;
(function (WebsocketEvent) {
    WebsocketEvent["RECONNECT"] = "RECONNECT";
    WebsocketEvent["LEVELUP"] = "LEVEL_UP";
    WebsocketEvent["DEVOURPLAYNOTIFICATION"] = "DEVOURPLAY_NOTIFICATION";
    WebsocketEvent["REFRESH"] = "REFRESH";
    WebsocketEvent["LOGOUT"] = "LOGOUT";
    WebsocketEvent["NOTIFICATION"] = "NOTIFICATION";
    WebsocketEvent["REWARDDISTRIBUTED"] = "REWARD_DISTRIBUTED";
    WebsocketEvent["QUESTPROGRESSED"] = "QUEST_PROGRESSED";
    WebsocketEvent["DISCORDMESSAGECREATE"] = "DISCORD_MESSAGE_CREATE";
    WebsocketEvent["DISCORDMESSAGEUPDATE"] = "DISCORD_MESSAGE_UPDATE";
    WebsocketEvent["DISCORDMESSAGEDELETE"] = "DISCORD_MESSAGE_DELETE";
    WebsocketEvent["DISCORDINITIALMESSAGES"] = "DISCORD_INITIAL_MESSAGES";
    WebsocketEvent["DISCORDERROR"] = "DISCORD_ERROR";
    WebsocketEvent["DISCORDUSERTYPING"] = "DISCORD_USER_TYPING";
    WebsocketEvent["DISCORDCHANNELUPDATE"] = "DISCORD_CHANNEL_UPDATE";
    WebsocketEvent["QUESTREFRESH"] = "QUEST_REFRESH";
})(WebsocketEvent = exports.WebsocketEvent || (exports.WebsocketEvent = {}));
function WebsocketEventFromJSON(json) {
    return WebsocketEventFromJSONTyped(json, false);
}
exports.WebsocketEventFromJSON = WebsocketEventFromJSON;
function WebsocketEventFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.WebsocketEventFromJSONTyped = WebsocketEventFromJSONTyped;
function WebsocketEventToJSON(value) {
    return value;
}
exports.WebsocketEventToJSON = WebsocketEventToJSON;
